import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-professional-bodies-w.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-professional-bodies-w.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { CreateApplicationProfessionalBodiesWConstants } from "./create-application-professional-bodies-w.constants";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationProfessionalBodiesWComponent = class CreateApplicationProfessionalBodiesWComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    recipientSelectService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    professionalBodiesForm;
    markImplementingAgentAsNotApplicableLabel = CreateApplicationProfessionalBodiesWConstants.MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_LABEL;
    markImplementingAgentAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesWConstants.MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantToImplementingAgentDetailsFormControlName = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    copyApplicantDetailsToImplementingAgentLabel = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_LABEL;
    markEngineerAsNotApplicableLabel = CreateApplicationProfessionalBodiesWConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_LABEL;
    markEngineerAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesWConstants.MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerFormControlName = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    markContractorAsNotApplicableLabel = CreateApplicationProfessionalBodiesWConstants.MARK_CONTRACTOR_AS_NOT_APPLICABLE_LABEL;
    markContractorAsNotApplicableFormControlName = CreateApplicationProfessionalBodiesWConstants.MARK_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME;
    copyApplicantDetailsToContractorFormControlName = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_CONTRACTOR_FORM_CONTROL_NAME;
    copyApplicantDetailsToContractorLabel = CreateApplicationProfessionalBodiesWConstants.COPY_APPLICANT_DETAILS_TO_CONTRACTOR_LABEL;
    implementingAgentFormControlName = CreateApplicationProfessionalBodiesWConstants.IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationProfessionalBodiesWConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = CreateApplicationProfessionalBodiesWConstants.RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME;
    showImplementingAgent = false;
    showEngineer = false;
    showContractor = false;
    implementingAgentDisableFilterBy = true;
    implementingAgentDisableAdd = true;
    implementingAgentDisableEditing = false;
    implementingAgentShowFields = true;
    implementingAgentIsInternal = false;
    implementingAgentGroups = [];
    implementingAgentLabel = CreateApplicationProfessionalBodiesWConstants.IMPLEMENTING_AGENT_LABEL;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = CreateApplicationProfessionalBodiesWConstants.ENGINEER_LABEL;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = CreateApplicationProfessionalBodiesWConstants.RESPONSIBLE_CONTRACTOR_LABEL;
    constructor(createApplicationService, recipientSelectService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.recipientSelectService = recipientSelectService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        try {
            if (this.appController.moduleSimulateMode) {
                this.implementingAgentGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.engineerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
                this.contractorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
            }
            else {
                this.implementingAgentGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.implementingAgentConsultantGroup);
                this.engineerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.engineerGroup);
                this.contractorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.responsibleContractorGroup);
            }
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("professionalBodiesForm");
        this.professionalBodiesForm = form;
        if (this.professionalBodiesForm.get("markImplementingAgentAsNotApplicable").value === true) {
            this.showImplementingAgent = true;
            this.professionalBodiesForm.get("implementingAgentRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
            copyControl.enable();
        }
        else {
            this.showImplementingAgent = false;
            this.professionalBodiesForm.get("implementingAgentRecipient").disable();
            this.professionalBodiesForm.get("implementingAgentRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
            copyControl.setValue(false);
            copyControl.disable();
        }
        if (this.professionalBodiesForm.get("markEngineerAsNotApplicable").value === true) {
            this.showImplementingAgent = true;
            this.professionalBodiesForm.get("engineerRecipients").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.enable();
        }
        else {
            this.showImplementingAgent = false;
            this.professionalBodiesForm.get("engineerRecipients").disable();
            this.professionalBodiesForm.get("engineerRecipients").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.setValue(false);
            copyControl.disable();
        }
        if (this.professionalBodiesForm.get("markContractorAsNotApplicable").value === true) {
            this.showImplementingAgent = true;
            this.professionalBodiesForm.get("responsibleContractorRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
            copyControl.enable();
        }
        else {
            this.showImplementingAgent = false;
            this.professionalBodiesForm.get("responsibleContractorRecipient").disable();
            this.professionalBodiesForm.get("responsibleContractorRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
            copyControl.setValue(false);
            copyControl.disable();
        }
        this.changeDetectorRefs.detectChanges();
    }
    onCopyApplicantDetailsToImplementingAgentChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("implementingAgentRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("implementingAgentRecipient").enable();
        }
    }
    onCopyApplicantDetailsToEngineerChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
        }
    }
    onCopyApplicantDetailsToContractorChecked(event) {
        if (event.currentTarget.checked === true) {
            this.professionalBodiesForm.get("responsibleContractorRecipient").disable();
        }
        else {
            this.professionalBodiesForm.get("responsibleContractorRecipient").enable();
        }
    }
    onMarkImplementingAgentAsNotApplicableChecked(event) {
        this.showImplementingAgent = event.currentTarget.checked;
        if (this.showImplementingAgent === false) {
            this.professionalBodiesForm.get("implementingAgentRecipient").disable();
            this.professionalBodiesForm.get("implementingAgentRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("implementingAgentRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToImplementingAgent");
            copyControl.enable();
        }
    }
    onMarkEngineerAsNotApplicableChecked(event) {
        this.showEngineer = event.currentTarget.checked;
        if (this.showEngineer === false) {
            this.professionalBodiesForm.get("engineerRecipients").disable();
            this.professionalBodiesForm.get("engineerRecipients").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("engineerRecipients").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToEngineer");
            copyControl.enable();
        }
    }
    onMarkContractorAsNotApplicableChecked(event) {
        this.showContractor = event.currentTarget.checked;
        if (this.showContractor === false) {
            this.professionalBodiesForm.get("responsibleContractorRecipient").disable();
            this.professionalBodiesForm.get("responsibleContractorRecipient").reset();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
            copyControl.setValue(false);
            copyControl.disable();
        }
        else {
            this.professionalBodiesForm.get("responsibleContractorRecipient").enable();
            const copyControl = this.professionalBodiesForm.get("copyApplicantDetailsToContractor");
            copyControl.enable();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: RecipientSelectService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationProfessionalBodiesWComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-professional-bodies-w",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationProfessionalBodiesWComponent);
export { CreateApplicationProfessionalBodiesWComponent };
